// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__bWKp9","bg_main":"style_bg_main__oBvCd","bg_top":"style_bg_top__X-+zf"};